/**
 * A-09 «Просмотр документа».
 *
 * ПС §06/§15: правила сообщества, условия и политика приватности открываются
 * внутри клиента. Актуальная версия и адрес берутся из `GET /config` → `legal`,
 * тексты — из `documents.ts`.
 */
import { useParams } from '@tanstack/react-router'

import { EmptyState } from '@shared/ui'

import { Screen } from '../../layouts/Screen'
import { LegalDocument } from './LegalDocument'
import { LEGAL_TEXTS, isLegalDocument } from './documents'

export function LegalScreen(): React.ReactElement {
  const { document: documentId } = useParams({ strict: false }) as { document: string }

  if (!isLegalDocument(documentId)) {
    return (
      <Screen title="Документ" back narrow>
        <EmptyState
          icon="document"
          title="Документ не найден"
          text="Проверьте ссылку или откройте раздел «Документы»."
        />
      </Screen>
    )
  }

  return (
    <Screen title={LEGAL_TEXTS[documentId].title} back narrow>
      <LegalDocument id={documentId} />
    </Screen>
  )
}
